import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/reducers';
import { GetDashboardResponse } from 'services/ManagerOneApi';
import { formatCurrency } from 'services/utils.service';
import { rawIntl } from 'services/intl';
import DataChart from '../OrderModeSalesCard/DataChart';
import NoDataChart from '../OrderModeSalesCard/NoDataChart';

import {
    ChartCenterLabel,
    ChartHeader,
    ChartSubHeader,
    DashboardCard,
    IDashboardData,
} from '../index';

const RevCenterSalesCard: FC<IDashboardData> = ({ dashboardData }) => {
    const [dataRows, setDataRows] = useState<(string | number)[][]>([]);
    const [netSalesTotal, setNetSalesTotal] = useState<string>('$0.00');
    const [hasData, setHasData] = useState<boolean>(false);
    const loading = useSelector((state: RootState) => state.common.loading);
    const [hasTotalReturns, setHasTotalReturns] = useState<boolean>(false);

    const totalReturns = dashboardData?.NetSales?.TotalReturns;

    const resetData = () => {
        setDataRows([]);
        setNetSalesTotal('$0.00');
        setHasData(false);
    };

    const i18n = {
        revCenterTitle: rawIntl.formatMessage({
            id: 'App.Containers.OrderModeSalesCard.RevCenterChart',
        }),
    };

    const updateData = (data: GetDashboardResponse) => {
        setHasTotalReturns(totalReturns > 0);
        try {
            const netSales = formatCurrency(data.NetSales.NetSales);
            if (data.NetSales.NetSales > 0) {
                const salesBreakdown = data.SalesByOrder.salesByOrder;

                const dataRows2 = Object.keys(salesBreakdown).map((key) => [
                    key,
                    salesBreakdown[key],
                ]);
                setDataRows(dataRows2);
                setNetSalesTotal(netSales);
                setHasData(true);
            } else {
                resetData();
            }
        } catch (e) {
            resetData();
        }
    };

    let height = '305px';

    if (hasTotalReturns) {
        height = '270px';
    } else if (dataRows && hasData) height = '290px';

    useEffect(() => {
        updateData(dashboardData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dashboardData]);

    return (
        <DashboardCard
            sx={{
                paddingTop: '0px',
                height: '304px',
            }}
        >
            {!loading && (
                <>
                    <ChartCenterLabel
                        style={{
                            height,
                            marginTop: dataRows && hasData ? '8px' : '0px',
                        }}
                    >
                        <ChartHeader id="sales-by-revenue-total">
                            {netSalesTotal}
                        </ChartHeader>
                        <ChartSubHeader>Net Sales</ChartSubHeader>
                    </ChartCenterLabel>
                    {dataRows && hasData ? (
                        <DataChart
                            dataRows={dataRows}
                            hasMoneyBack={hasTotalReturns}
                            moneyBack={totalReturns}
                            orderMode={false}
                        />
                    ) : (
                        <NoDataChart title={i18n.revCenterTitle} />
                    )}
                </>
            )}
        </DashboardCard>
    );
};

export default RevCenterSalesCard;
